// Generated by scripts/news/fetchLatestNews.mjs. Do not edit by hand.
export const allNewsUrl = "https://www.starapp.fun/happypet/news/"

const records = [
  {
    "title": "Emotional Intelligence Test Across Five Skills",
    "excerpt": "Reflect on emotional awareness, regulation, self-motivation, empathy, and communication through the 83-question MindScope EQ experience.",
    "publishedAt": "2026-08-31",
    "url": "https://www.starapp.fun/happypet/news/emotional-intelligence-test-guide/",
    "featureImage": "/happypet/news/wp-content/uploads/2026/09/38-emotional-intelligence-test.webp",
    "tag": "Self Discovery"
  },
  {
    "title": "Temperament Test: Explore Four Classic Patterns",
    "excerpt": "Explore emotional intensity, pace, adaptability, relationships, and action style through the MindScope four-temperament experience.",
    "publishedAt": "2026-08-31",
    "url": "https://www.starapp.fun/happypet/news/temperament-test-self-discovery/",
    "featureImage": "/happypet/news/wp-content/uploads/2026/09/37-temperament-type-test.webp",
    "tag": "Self Discovery"
  },
  {
    "title": "Attachment Style Test for Relationship Reflection",
    "excerpt": "Reflect on closeness, reassurance, independence, trust, conflict, and boundaries with the 72-question MindScope attachment style experience.",
    "publishedAt": "2026-08-31",
    "url": "https://www.starapp.fun/happypet/news/attachment-style-test-reflection/",
    "featureImage": "/happypet/news/wp-content/uploads/2026/09/36-attachment-style-test.webp",
    "tag": "Self Discovery"
  }
]

export const latestNews = Object.freeze(records.map((article) => Object.freeze(article)))
